import { render, staticRenderFns } from "./QualityControlRelatedList.vue?vue&type=template&id=a9a9e984"
import script from "./QualityControlRelatedList.vue?vue&type=script&lang=js"
export * from "./QualityControlRelatedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports